var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { CacheClient, CacheLocation } from '../basics/client-caching.service';
import { autoinject } from "aurelia-dependency-injection";
import { RequestClient } from "../basics/request-client.service";
import * as QueryConstants from '../../constants/queries/query.constants';
import { DataType, GetAllQueriesRequest, GetQueriesRequest, PersistQueryRequest } from '../../models/queries/queries.models';
import { EnumUtilities } from "../../utilities/enum-utilities";
import { toNative } from '../../utilities/promise-utils';
var QueriesClientService = /** @class */ (function () {
    function QueriesClientService(requestClient, clientCache) {
        this.requestClient = requestClient;
        this.clientCache = clientCache;
        this.cacheKeyGetMetaDataWithDynamicProperties = "GetMetaDataWithDynamicProperties";
    }
    QueriesClientService.prototype.getEntityModels = function () {
        if (!this._entityMetadataPromise) {
            this._entityMetadataPromise = toNative(this.requestClient.get(QueryConstants.Urls.EntityMetaData, null));
        }
        return this._entityMetadataPromise;
    };
    QueriesClientService.prototype.getEntityModelWithDynamicProperties = function (entityName) {
        var _this = this;
        var cacheKey = "".concat(this.cacheKeyGetMetaDataWithDynamicProperties, "_").concat(entityName);
        var promise = new Promise(function (resolve, reject) {
            _this.clientCache.get(cacheKey, CacheLocation.SessionStorage).then(function (x) {
                if (x) {
                    resolve(x);
                }
                else {
                    _this.requestClient.get(QueryConstants.Urls.GetMetaDataWithDynamicProperties, { entityName: entityName })
                        .then(function (result) {
                        _this.clientCache.put(cacheKey, result, CacheLocation.SessionStorage);
                        resolve(result);
                    }, function (error) {
                        reject(error);
                    });
                }
            });
        });
        return promise;
    };
    QueriesClientService.prototype.getData = function (url) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            _this.requestClient.get(url, null, true)
                .then(function (result) {
                if (result.value && result.value[0] &&
                    result.value[0]["groupedResult"]) {
                    if (result.value[0] && !result.value[0].dynamicProperties) {
                        delete result.value[0].dynamicProperties;
                    }
                    if (result.value[0]["groupedResult"].length > 0) {
                        result.value[0]["groupedResult"].forEach(function (x) {
                            result.value[0][x["key"]] = x["data"];
                        });
                    }
                    delete result.value[0]["groupedResult"];
                }
                resolve(result);
            }, function (error) {
                reject(error);
            });
        });
        return promise;
    };
    QueriesClientService.prototype.getQueryOperators = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this._entityMetaDataModelOperatorsPromise) {
                _this._entityMetaDataModelOperatorsPromise.then(function (result) {
                    resolve(_this.mapOperators(result));
                }, function (error) {
                    reject(error);
                });
            }
            _this._entityMetaDataModelOperatorsPromise = toNative(_this.requestClient.get(QueryConstants.Urls.EntityMetaDataOperators, null));
            _this._entityMetaDataModelOperatorsPromise.then(function (result) {
                resolve(_this.mapOperators(result));
            }, function (error) {
                reject(error);
            });
        });
    };
    QueriesClientService.prototype.getQueriesForUser = function (entityType) {
        return toNative(this.requestClient.get(QueryConstants.Urls.Queries, new GetQueriesRequest(entityType)));
    };
    QueriesClientService.prototype.getQueries = function (entityType) {
        return toNative(this.requestClient.get(QueryConstants.Urls.QueriesAll, new GetAllQueriesRequest(entityType)));
    };
    QueriesClientService.prototype.getGroupedData = function (entityType, nameProperty, aggregateOperator, aggregateProperty, filter) {
        var _this = this;
        if (aggregateOperator === void 0) { aggregateOperator = null; }
        if (aggregateProperty === void 0) { aggregateProperty = null; }
        if (filter === void 0) { filter = null; }
        var uri = "/odata/" + entityType + "/Genesis.GroupBy(column='" + nameProperty + "',propertyForAggregation='" + aggregateProperty + "',aggregationType='" + aggregateOperator + "')" + (filter ? filter : '');
        return new Promise(function (resolve, reject) {
            _this.getData(uri)
                .then(function (data) {
                resolve(data.value);
            })
                .catch(function (error) {
            });
        });
    };
    QueriesClientService.prototype.getGroupedDataUri = function (uri) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.getData(uri)
                .then(function (data) {
                resolve(data.value);
            })
                .catch(function (error) {
            });
        });
    };
    QueriesClientService.prototype.persistQueries = function (queries, queriesToRemove) {
        return this.requestClient.post(QueryConstants.Urls.Queries, {}, new PersistQueryRequest(queries, queriesToRemove));
    };
    QueriesClientService.prototype.mapOperators = function (items) {
        var e_1, _a, e_2, _b, e_3, _c;
        var result = {};
        var values = EnumUtilities.getValues(DataType);
        try {
            for (var values_1 = __values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
                var value = values_1_1.value;
                result[value] = new Array();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            //add all the items in a 'dictionary type' so that we can access them easily
            for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                var item = items_1_1.value;
                try {
                    for (var _d = (e_3 = void 0, __values(item.supportedTypes)), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var type = _e.value;
                        result[type].push(item);
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (items_1_1 && !items_1_1.done && (_b = items_1.return)) _b.call(items_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return result;
    };
    QueriesClientService.prototype.getNameProperties = function (entityType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.getEntityModels()
                .then(function (entityMetaData) {
                var e_4, _a;
                if (entityMetaData) {
                    if (entityType) {
                        var result = [];
                        try {
                            for (var entityMetaData_1 = __values(entityMetaData), entityMetaData_1_1 = entityMetaData_1.next(); !entityMetaData_1_1.done; entityMetaData_1_1 = entityMetaData_1.next()) {
                                var row = entityMetaData_1_1.value;
                                if (row.name === entityType) {
                                    result = row.projectionProperties;
                                }
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (entityMetaData_1_1 && !entityMetaData_1_1.done && (_a = entityMetaData_1.return)) _a.call(entityMetaData_1);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                        resolve(result);
                    }
                }
                resolve([]);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    QueriesClientService = __decorate([
        autoinject,
        __metadata("design:paramtypes", [RequestClient, CacheClient])
    ], QueriesClientService);
    return QueriesClientService;
}());
export { QueriesClientService };
